
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

function AlertDialogForm({ request, approver }) {
  return (
    // <div>

    //   <div className="row">
    //   <p><strong>Idea:</strong> {request?.proposedIdea}</p>
    //   <p><strong>Approver:</strong> {approver?.name}</p>
    //   <p><strong>Status:</strong> {approver?.status}</p>

    // </div>
    // <div className="row">
    //   <p><strong>Idea:</strong> {request?.proposedIdea}</p>
    //   <p><strong>Approver:</strong> {approver?.name}</p>
    //   <p><strong>Status:</strong> {approver?.status}</p>

    // </div>
    // </div>










 <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={10} sm={6}>
            
                {/* <Typography variant="body1">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: getStatusColor(selectedIdea.status) }}>
                    {selectedIdea.status}
                  </span>
                </Typography> */}
                <Typography variant="body1">
                  <strong>Idea Category:</strong> {request.idea_category_x}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {request.partno}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {request.part_description}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong> {request.proposed_idea_x}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong>{" "}
                  {request.current_condition}
                </Typography>
               
              </Grid>
              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Savings:</strong> {request.benefit}
                </Typography>
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {request.idea_effective}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {request.model}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {request.varient}
                </Typography>

                <Typography variant="body1">
                  <strong>Sub Variant:</strong> {request.subvarient}
                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {request.domain}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {request.function}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {request.location}
                </Typography>

                <Typography variant="body1">
                  <strong>Document:</strong>{" "}
                  {request.filepath ? (
                    <a
                      href={request.filepath}
                      target="_blank"
                      rel="noreferrer"
                    >
                      View File
                    </a>
                  ) : (
                    "No File"
                  )}
                </Typography>
              </Grid>
            </Grid>
          
  );
}

export default AlertDialogForm;



// import React from "react";

// function AlertDialogForm({ paginatedIdeas, currentPage, itemsPerPage, getStatusColor }) {
//   return (
//     <div className="container mt-4">
//       <div className="table-responsive">
//         <table className="table table-bordered table-striped custom-table">
//           <thead className="thead-dark">
//             <tr>
//               <th>S.No</th>
//               <th>Status</th>
//               <th>Idea Category</th>
//               <th>Part No</th>
//               <th>Description</th>
//               <th>Proposed Idea</th>
//               <th>Current Condition</th>
//               <th>Savings</th>
//               <th>Aggregate</th>
//               <th>Model</th>
//               <th>Variant</th>
//               <th>Domain</th>
//               <th>Function</th>
//               <th>Location</th>
//               <th>Document</th>
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedIdeas.map((req, index) => (
//               <tr key={req.id}>
//                 <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
//                 <td style={{ color: getStatusColor(req.status) }}>
//                   {req.status}
//                 </td>
//                 <td>{req.idea_category}</td>
//                 <td>{req.partno}</td>
//                 <td>{req.part_description}</td>
//                 <td>{req.proposed_idea}</td>
//                 <td>{req.current_condition}</td>
//                 <td>{req.benefit}</td>
//                 <td>{req.idea_effective}</td>
//                 <td>{req.model}</td>
//                 <td>{req.varient}</td>
//                 <td>{req.domain}</td>
//                 <td>{req.function}</td>
//                 <td>{req.location}</td>
//                 <td>
//                   {req.filepath ? (
//                     <a href={req.filepath} target="_blank" rel="noreferrer">
//                       View File
//                     </a>
//                   ) : (
//                     "No File"
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// export default AlertDialogForm;
